import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { updateCurrency } from "../../../utils/common";
import isEmpty from "lodash.isempty";
import ProductTag from "../../atoms/ProductTag";
import RateAndReview from "../../molecules/rateAndReview";
/**
 *
 * @param {*} param0
 * @returns
 */
const ProductInfo = ({
  title,
  price,
  isHideSavedPercent = false,
  review,
  isSmallReviewTag,
  productAttributes,
  isMobile,
}) => {
  const selectedCurrency = useSelector((state) => state?.currencyList?.userSelectedCurrency);

  return (
    <div className="pt-8 sm:p-12">
      {title && (
        <div
          className={`mb-4 ${isMobile ? "line-clamp-2" : "line-clamp-1"}  text-12 font-500 leading-0 text-fnp-500 md:text-14`}
          itemProp="name"
        >
          {title}
        </div>
      )}
      {price && (
        <>
          <meta itemProp="priceCurrency" content={isEmpty(selectedCurrency) ? "INR" : selectedCurrency?.currency?.id} />
          <div className="priceDetails mb-8 flex flex-wrap items-center gap-4">
            {price?.percentSaved > 0 && (
              <>
                <span className="overflow-hidden text-ellipsis whitespace-nowrap text-12 font-400 text-grey-400 line-through">
                  {updateCurrency(selectedCurrency, price?.mrp ? price?.mrp : price?.listPrice)}
                </span>
              </>
            )}
            <span className={`${price?.percentSaved > 0 ? "ml-4" : ""} mr-2 text-14 font-600`}>
              {updateCurrency(selectedCurrency, price?.price ? price?.price : price?.listPrice)}
            </span>
            {!isHideSavedPercent && price?.percentSaved > 0 && (
              <span
                className="w-fit py-4 pl-4 pr-8 text-10 font-600 text-offer-900"
                style={{
                  backgroundImage: "linear-gradient(to right, rgba(0, 138, 0,0), rgba(0, 138, 0,0.28))",
                  clipPath: "polygon(0 100%, 90% 100%, 100% 0, 0% 0)",
                }}
              >
                {Math.round(price?.percentSaved)}% OFF
              </span>
            )}
          </div>
        </>
      )}
      <div className="flex w-full flex-wrap gap-4 md:gap-8">
        {productAttributes && <ProductTag productAttributes={productAttributes} isMobile={isMobile} />}
        {(review && review?.ratingCount > 100) || (review && review?.reviewCount > 100) ? (
          <RateAndReview
            review={review}
            isReviewTextHide={true}
            isSmallReviewTag={isSmallReviewTag}
            isSchema={false}
            classes="static"
            isPadding={false}
          />
        ) : (
          !isMobile && (
            <div
              className={`bottom-8 flex min-h-[17px] w-max items-center gap-4 rounded-24 bg-white-900 bg-opacity-70 p-0  font-500 leading-0 text-fnp-500 ${isSmallReviewTag ? "text-10" : "text-12 xxl:text-14"}`}
            />
          )
        )}
      </div>
    </div>
  );
};

ProductInfo.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({
    price: PropTypes.number,
    listPrice: PropTypes.number,
    mrp: PropTypes.number,
    percentSaved: PropTypes.number,
  }).isRequired,
  isHideSavedPercent: PropTypes.bool,
  review: PropTypes.object,
  isSmallReviewTag: PropTypes.bool,
  productAttributes: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};

export default React.memo(ProductInfo);
